import { useSubscription } from './use-subscription';
import { useObservableStateInternal } from './internal/use-observable-state-internal';
export function useObservableState(state$OrInit, initialState) {
    return useObservableStateInternal(useSubscription, state$OrInit, initialState);
}
//# sourceMappingURL=use-observable-state.js.map